import type { ReactiveBatchQueryOptions, ReactiveQueryBatch } from '@w/utils'
import type { Tel } from '@w/tel'
import type { AnyRoute, ParamsRecord, SearchRecord } from './types'

type RouteQueryFnContext = {
  signal: AbortSignal
  queryKey: unknown[]
  tel?: Tel
}

export type RouteQueryBatch = ReactiveQueryBatch<RouteQueryFnContext>

export type RouteQueryOptionsApi = {
  exactMatch: boolean
  options<TData>(
    queryFn: (batch: RouteQueryBatch) => Promise<TData>,
    overrides?: Partial<
      Omit<
        ReactiveBatchQueryOptions<TData, RouteQueryFnContext>,
        'queryKey' | 'queryFn'
      >
    >,
  ): ReactiveBatchQueryOptions<TData, RouteQueryFnContext>
}

export function routeOptions<TData>(
  route: Pick<AnyRoute, 'id' | 'fullPath'>,
  params: ParamsRecord,
  search: SearchRecord,
  queryFn: (batch: RouteQueryBatch) => Promise<TData>,
  overrides?: Partial<
    Omit<
      ReactiveBatchQueryOptions<TData, RouteQueryFnContext>,
      'queryKey' | 'queryFn'
    >
  >,
): ReactiveBatchQueryOptions<TData, RouteQueryFnContext> {
  return {
    ...overrides,
    queryKey: ['route', route.id, params, search],
    queryFn,
  }
}

export function createRouteOptionsApi(
  route: Pick<AnyRoute, 'id' | 'fullPath'>,
  params: ParamsRecord,
  search: SearchRecord,
  exactMatch: boolean,
): RouteQueryOptionsApi {
  return {
    exactMatch,
    options: (queryFn, overrides) =>
      routeOptions(route, params, search, queryFn, overrides),
  }
}
